<template>
  <div id="mapid">

  </div>
</template>

<script>
import * as echarts from "echarts";
import { getClassicCaseAddressList } from "@/api/case.js"
import dataJson from "./map.json";
import { createLocalizedMapJson, getLocalizedMapName } from "@/utils/mapLocale";
export default {
  mounted() {
    getClassicCaseAddressList({ isRelease: this.$store.state.editStatus }).then(res => {
      this.init(res.data);
    })

  }, methods: {
    init(arrData) {
      let myChart = echarts.init(document.getElementById("mapid"));
      const language = this.$store.state.language;
      let uploadDataUrl = createLocalizedMapJson(dataJson, language);

      echarts.registerMap("china", uploadDataUrl);
      var mapName = "china";
      var data = [];
      arrData.forEach(e => {
        data.push({
          name: getLocalizedMapName(dataJson, e.addressName, language),
          value: 100
        })
      })
      var geoCoordMap = {};
      var mapFeatures = uploadDataUrl.features;
      //  console.log(mapFeatures)
      mapFeatures.forEach(function (v) {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        geoCoordMap[name] = v.properties.cp;
      });

      var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
        return res;
      };
      var convertToLineData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          res.push({
            coords: [
              [120.0586, 32.915, 100],
              data[i].value,

            ],
            lineStyle: { color: "#f5d06c" }
          })
        }
        return res;
      };
      let option = {



        visualMap: {
          show: false,
          min: 0,
          max: 100,
          left: "left",
          top: "bottom",
          text: ["高", "低"], // 文本，默认为数值文本
          calculable: true,
          seriesIndex: 1,
          inRange: {
            // color: ['#3B5077', '#031525'] // 蓝黑
            //   color: ['#ffc0cb', '#800080'] // 红紫
            // color: ['#3C3B3F', '#605C3C'] // 黑绿
            //   color: ['#0f0c29', '#302b63', '#24243e'] // 黑紫黑
            // color: ['#23074d', '#cc5333'] // 紫红
            color: "#378fe9", // 蓝绿
            //   color: ['#1488CC', '#2B32B2'] // 浅蓝
            //  color: ['#00467F', '#A5CC82', '#ffc0cb'] // 蓝绿红
            // color: ['#00467F', '#A5CC82'] // 蓝绿
            // color: ['#00467F', '#A5CC82'] // 蓝绿
            // color: ['#00467F', '#A5CC82'] // 蓝绿
          },
        },
        geo: {
          show: true,
          map: mapName,
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            },
          },
          roam: false,
          itemStyle: {
            normal: {
              areaColor: "#378fe9",
              borderColor: "#fff",
              borderWidth: 1
            },
            emphasis: {
              areaColor: "#3490ee",
            },
          },
        },

        series: [
          //散点
          {
            name: "散点",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: convertData(data),
            symbolSize: function (val) {
              return 16;
            },
            rippleEffect: {
              period: 3,//动画的周期，秒数
              scale: 2,//动画中波纹的最大缩放比例。
              brushType: "stroke",//波纹的绘制方式，可选 'stroke' 和 'fill'。
            },
            label: {
              normal: {

                formatter: " {b}",
                position: "top",
                show: true,
                textBorderColor: "#666",
                textBorderWidth: 1
              },
              emphasis: {
                show: true,
              },
            },
            itemStyle: {
              normal: {
                color: "#f5d06c",
                shadowBlur: 20,
                shadowColor: "#333",
              },
            },
          },
          //区域颜色
          {
            type: "map",
            map: mapName,
            geoIndex: 0,
            aspectScale: 0.75, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: "#3490ee",
                borderColor: "#fff",
              },
              emphasis: {
                areaColor: "#2B91B7",
              },
            },
            animation: false,
            data: data,
          },
          {
            type: "lines",
            zlevel: 2,
            effect: {
              show: true,
              period: 5, //箭头指向速度，值越小速度越快
              trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "arrow", //箭头图标
              symbolSize: 8, //图标大小
            },
            lineStyle: {
              normal: {
                color: "#3490ee",
                width: 2, //尾迹线条宽度
                opacity: 0.2, //尾迹线条透明度
                curveness: 0.3, //尾迹线条曲直度
              },
            },
            data: convertToLineData(convertData(data)),
          },


        ],
      };
      //  myChart.setOption(option);
      //取代传统设置，加入自动适应屏幕代码
      myChart.setOption(option);
      //假设实例的名字是myChart,在echats配置完实例以后,配置下面几行代码即可
      window.onresize = function () {
        myChart.resize();
      };

    }
  }
}
</script>

<style lang="scss" scoped>
#mapid {
  width: 1100px;
  height: 500px;
}
</style>
